const Role = {
    ADMIN: "admin",
    SUPER_ADMIN: "super admin",
    USER: "user",
    DRIVER: "driver",
}

export default Role 
